export default __webpack_public_path__ + "static/media/quickshot4.ee7c539d.png";